import { createRouter, createWebHistory } from "vue-router";
import Domains from "./views/Domains.vue";
// import UserRoles from "./views/UserRoles.vue";
import Events from "./modules/events/views/Events.vue";
import { NtaNotFound } from "@lr-notitia/notitia-ui/components";

import dataspacesRoutes from "./modules/dataspaces/router";
import workspacesRoutes from "./modules/workspaces/router";
import processesRoutes from "./modules/processes/router";

const routes = [
	{
		path: "/:pathMatch(.*)*",
		name: "NotFound",
		component: NtaNotFound,
	},
	{
		path: "/",
		name: "Domains",
		component: Domains,
	},
	{
		path: "/:domainId",
		redirect: (to: any) => `/${to.params.domainId}/template/processes`,
	},
	// {
	// 	path: "/:domainId/user-roles",
	// 	name: "UserRoles",
	// 	component: UserRoles,
	// },
	{
		path: "/:domainId/template/events",
		name: "Events",
		component: Events,
	},
	...dataspacesRoutes,
	...workspacesRoutes,
	...processesRoutes,
];

export default createRouter({
	history: createWebHistory(),
	routes,
});
